import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'
import RootDir from '../apiaddress.json'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Payday Loan Finance"/>				
				<h1 className="headings" style={{textAlign:"center",color:"green"}}><small>{this.state.CompName}--Payday Loan Provider for Canadians</small></h1>				
				<div id="contentwrapper" >
					<div id="contentcolumn">
						<Link className="applybutton" to = "/Apply"><img border="0" src={ApplyImg} alt="Payday loans application"/></Link>
						<Link className="applybutton" to = "/Member"><img border="0" src={ExistCustomer} alt="Payday loans Returning Customers"/></Link>
					</div>
				</div>
				<div id="rightcolumn">
					<div className="innertext">
						<b style={{color:"green"}}>No Fax</b><br/>
						<b style={{color:"green"}}>Fast and Easy</b><br/>
						<b style={{color:"green"}}>No hidden cost</b><br/>
						<b style={{color:"green"}}>No Credit Check</b><br/>
						<b style={{color:"green"}}>Up to $600 until next pay day</b><br/>
						<b style={{color:"green"}}>Cash advance deposited directly to your account</b><br/>
					</div>
				</div>
				<div id="leftcolumn" title="Your payday loans"><img src={CanMoney} alt="Your Payday loans and cash advance"/></div>
				<div id="bottom"><br/>
					<h1 style={{color:"blue"}}>Control Your Finance</h1>
					<h4 style={{color:"grey"}}>Use the following links to learn more about managing your finance responsibly and improve your credit standing</h4>
					<ul>
						<li>Learn how to use your Payday loans: <Link to = {{pathname: "https://www.cpla-acps.ca/"}} style={{color:"green"}} target="_blank">Canadian Payday Loan Association</Link></li>
						<li>Find how to protect your payday loans: <Link to = {{pathname:"https://www.ontario.ca/page/ministry-government-and-consumer-services"}} target="_blank" style={{color:"green"}} >Ministry of Consumer Services</Link></li>
						<li>Know your financial rights: <Link to = {{pathname:"https://www.canada.ca/en/financial-consumer-agency.html"}} target="_blank" style={{color:"green"}} >Financial Consumer Agency of Canada</Link></li>
						<li>Improve your credit reports: <Link to = {{pathname:"https://www.creditcanada.com/"}} target="_blank" style={{color:"green"}} >Credit Canada</Link></li>
					</ul>
				</div>								
			</div>
		)
	}
}

export default HomtContents